import { Box, Typography } from '@mui/material';
import { MRT_ColumnDef } from 'mantine-react-table';
import React, { useMemo } from 'react';
import { AddOnStatsPoint } from '../../../../types/dashboard';
import GenericTable from '../../../../shared/GenericTable';
import { dashboardSummaryTableDefaults } from '../../dashboardReportTableConfig';

type AddOnsBookedReportListProps = {
    points: AddOnStatsPoint[];
};

type SummaryRow = AddOnStatsPoint & { id: number };

export default function AddOnsBookedReportList({
    points,
}: AddOnsBookedReportListProps) {
    const columns: MRT_ColumnDef<SummaryRow>[] = useMemo(
        () => [
            {
                accessorKey: 'label',
                header: 'Period',
                size: 180,
            },
            {
                accessorKey: 'addOnCount',
                header: 'Add-ons Booked',
                size: 180,
            },
        ],
        [],
    );

    const rows = useMemo(
        () =>
            (points ?? []).map((point, index) => ({
                id: index + 1,
                ...point,
            })),
        [points],
    );

    if (!rows.length) {
        return (
            <Typography sx={{ mt: 4 }} variant='body2'>
                No add-ons booked found for this selection.
            </Typography>
        );
    }

    return (
        <Box sx={{ width: '100%' }}>
            <GenericTable
                {...dashboardSummaryTableDefaults}
                columns={columns}
                data={rows}
                tableName='Add-ons Booked Summary'
            />
        </Box>
    );
}
